module.exports = __webpack_public_path__ + "d664201f/img/revit-icon.5ff0d581.svg";